import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { intakeQuestionnaireActions } from '../../../../../../../store';

import type { AppDispatch, RootState } from '../../../../../../../store';
import type { ChildSchedulePayload } from '../../../../../../common';

export default function useIntakeChildSchedule() {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();
  const { intakeQuestionnaireId } = useParams<'intakeQuestionnaireId'>();

  const schedules = useSelector(
    (state: RootState) =>
      state.intakeQuestionnaire.intakeQuestionnaireDetails?.child_info?.schedule ?? [],
  );
  const isSaving = useSelector(
    (state: RootState) =>
      state.intakeQuestionnaire.createChildScheduleLoading ||
      state.intakeQuestionnaire.deleteChildScheduleLoading,
  );
  const notAttendingSchool = useSelector(
    (state: RootState) =>
      state.intakeQuestionnaire.intakeQuestionnaireDetails?.not_attending_school ?? false,
  );

  const create = useCallback(
    async (data: ChildSchedulePayload) => {
      if (!intakeQuestionnaireId) return false;
      const result = await dispatch(
        intakeQuestionnaireActions.createIntakeChildSchedule({
          intakeQuestionnaireId,
          data,
          getAccessTokenSilently,
        }),
      );
      return intakeQuestionnaireActions.createIntakeChildSchedule.fulfilled.match(result);
    },
    [dispatch, getAccessTokenSilently, intakeQuestionnaireId],
  );

  const remove = useCallback(
    async (scheduleId: number) => {
      if (!intakeQuestionnaireId) return false;
      const result = await dispatch(
        intakeQuestionnaireActions.deleteIntakeChildSchedule({
          intakeQuestionnaireId,
          scheduleId,
          getAccessTokenSilently,
        }),
      );
      return intakeQuestionnaireActions.deleteIntakeChildSchedule.fulfilled.match(result);
    },
    [dispatch, getAccessTokenSilently, intakeQuestionnaireId],
  );

  return {
    schedules,
    notAttendingSchool,
    isSaving,
    create,
    remove,
  };
}
